// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"

// https://prismjs.com/examples.html
// https://github.com/PrismJS/prism/tree/master/themes
// require("prismjs/themes/prism-solarizedlight.css")
require("prismjs/themes/prism.css")